/* eslint-disable react-hooks/exhaustive-deps */
import Image from 'next/image'
import { Camera } from 'src/assets/images'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { UploadOutlined, FilePdfOutlined } from '@ant-design/icons'
import styles from './CustomFileInput.module.scss'
import { CustomCol, CustomLink } from 'src/components'
import { Button, Row, Upload, Form, UploadProps, Popconfirm } from 'antd'
import { useWindowSize } from 'src/app/hooks'

interface CustomFileInputProps extends UploadProps {
  name: string,
  required?: boolean
  value?: string
  // eslint-disable-next-line no-unused-vars
  onChangeFileUrl?: (value: string) => void
  allowedExtensions?: string,
  showFileIcon?: boolean
  returnFile?: boolean
  onResetFile?: boolean
}

const CustomFileInput: React.FC<CustomFileInputProps> = (props) => {
  const {
    name,
    required = false,
    onChangeFileUrl = null,
    value = null,
    allowedExtensions = 'application/pdf',
    showFileIcon = false,
    returnFile = false,
    onResetFile = false,
    ...restProps } = props
  const { t } = useTranslation()
  const [fileSource, setFileSource] = useState(value)
  const [fileName, setFileName] = useState(null)
  const { isMobile } = useWindowSize()
  useEffect(() => {
    if (onResetFile) {
      handleResetFile()
    }
  }, [onResetFile])


  const handleFileChange = ({ file }: { file: any }) => { manageFileChange(file) }

  const handleResetFile = () => {
    setFileSource(null)
    setFileName(null)
    if (onChangeFileUrl) {
      onChangeFileUrl(null)
    }
  }

  const getValue = ({ file }) => {
    manageFileChange(file)
    return returnFile ? file : URL.createObjectURL(file)
  }

  const manageFileChange = (file: File) => {
    setFileName(file?.name)

    const fileUrl = URL.createObjectURL(file)
    setFileSource(fileUrl)
    if (onChangeFileUrl) {
      onChangeFileUrl(fileUrl)
    }
  }

  useEffect(() => {
    if (!value) {
      setFileSource(null)
      setFileName(null)
    } else {
      setFileName(t('general.ClickHere'))
    }
  }, [value])

  return (
    <Row className={styles.content}>
      <CustomCol lg={11}>
        {fileSource ? (
          <div className={styles.imageContent}>
            <CustomLink link={fileSource} label={fileName} showIcon={false} />
          </div>
        ) : (
          <div className={styles.emptyImage}>
            {!showFileIcon ? (
              <Image src={Camera} width={56} height={56} alt='empty-image' />
            ) : (
              <FilePdfOutlined style={{ fontSize: isMobile ? '25px' : '45px' }} />
            )
            }
          </div>
        )}

      </CustomCol>
      <CustomCol lg={13}>
        <Form.Item
          name={name}
          getValueFromEvent={getValue}
          className={styles.uploadInput}
          rules={[
            {
              message: t('general.RequiredValidation'),
              validator: () => {
                if (!required) {
                  return Promise.resolve()
                } else if (required && !fileSource) {
                  return Promise.reject(t('general.RequiredValidation'))
                } else { return Promise.resolve() }
              }
            }
          ]}
        >
          <Upload
            beforeUpload={() => false}
            accept={allowedExtensions}
            fileList={[]}
            onChange={handleFileChange}
            showUploadList={false}
            {...restProps}
          >
            <Button
              htmlType='button'
              icon={<UploadOutlined />}
              className={styles.uploadButton}
            >
              {t('admin.MassiveCalculate.UploadFile')}
            </Button>
          </Upload>
        </Form.Item>

        {fileSource && (
          <Popconfirm
            title={t('general.SureDelete')}
            onConfirm={handleResetFile}
            okText={t('general.Yes')}
            cancelText={t('general.Cancel')}
          >
            <Button
              type='text'
              htmlType='button'
              size={'large'}
              className={styles.resetButton}
            >
              {t('Projects.RemoveFile')}
            </Button>
          </Popconfirm>
        )}
      </CustomCol>
    </Row>
  )
}

export default CustomFileInput
